import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
var OFFSET_PARAM = "offset";
var parseOffset = function (raw) {
    var parsed = Number(raw);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : 0;
};
/**
 * Keeps the current page in the URL so returning from an edit route lands on the same
 * page, and so a list URL can be shared or reloaded. Paging replaces the history entry
 * instead of pushing one, otherwise Back would walk through every visited page.
 */
export var usePageOffsetParam = function () {
    var history = useHistory();
    var location = useLocation();
    var pageOffset = useMemo(function () { return parseOffset(new URLSearchParams(location.search).get(OFFSET_PARAM)); }, [location.search]);
    var setPageOffset = useCallback(function (offset) {
        var params = new URLSearchParams(location.search);
        if (offset > 0) {
            params.set(OFFSET_PARAM, String(offset));
        }
        else {
            params.delete(OFFSET_PARAM);
        }
        history.replace({ search: params.toString() });
    }, [history, location.search]);
    return { pageOffset: pageOffset, setPageOffset: setPageOffset };
};
